import $ from "jquery";
import select2 from "select2";

// TODO: Should probably move away from abide, its not very configurable.

function emailValidator($el, required, parent) {
  const email = $el.val();
  const $error = $el.siblings(".form-error");

  if (!RegExp(/.+@.+\..+/g).test(email)) {
    $error.text("Please enter a valid email");
    return false;
  }

  let data = {
    email: email,
  };

  data[window.csrfTokenName] = window.csrfTokenValue;

  $.ajax({
    method: "POST",
    url: window.checkEmailAction,
    data: data,
  }).done(function (res) {
    if (res.emailExists) {
      $error.text("That email is already registered");
      $(".registration-form").foundation("addErrorClasses", $el);
    } else {
      $(".registration-form").foundation("removeErrorClasses", $el);
    }
  });

  if ($el.attr("data-invalid") == undefined) {
    return true;
  } else {
    return false;
  }
}

Foundation.Abide.defaults.validators["custom_email"] = emailValidator;

$(function () {
  const $form = $(".registration-form");
  const orgId = window.organizationsId;
  const spId = window.serviceProvidersId;
  const restaurantsId = window.restaurantsId;
  const retailersId = window.retailersId;

  if ($form.length) {
    const $groupType = $form.find("[name=userGroupId]");
    const $orgElems = $form.find("[data-org]");
    const $spElems = $form.find("[data-sp]");
    const $restaurantElems = $form.find("[data-restaurant]");
    const $retailElems = $form.find("[data-retailer]");

    revealElems($groupType.filter(":checked").val());

    $groupType.change(function (e) {
      const $target = $(e.target);
      const groupId = $target.val();
      revealElems(groupId);
    });

    /**
     * Set up Service Provider multi-select
     */
    $form.find("#serviceTypes").select2({
      maximumSelectionLength: 5,
      width: "100%",
    });

    /**
     * Abide Hide Callout When Things Are Fixed
     */
    $form.on("forminvalid.zf.abide", function (ev, frm) {
      $(".alert.callout").removeClass("hide");
    });

    $form
      .find("input, select, text-area")
      .on("change.zf.abide", function (ev, elem) {
        var invalid_fields = $form.find("[data-invalid]");
        if (invalid_fields.length == 0) {
          $(".alert.callout").addClass("hide");
        } else {
          $(".alert.callout").removeClass("hide");
        }
      });

    /**
     * Show account details on summary page
     */
    const $accountSummary = $("[data-account-summary]");

    const $establishment = $form.find('[name="fields[establishment]"]');
    const $email = $form.find("[name=email]");
    const $contactFirst = $form.find('[name="firstName"]');
    const $contactLast = $form.find('[name="lastName"]');
    const $establishmentSummary = $form.find("[data-summary=establishment]");
    const $emailSummary = $form.find("[data-summary=email]");
    const $contactSummary = $form.find("[data-summary=contact]");

    $accountSummary.click(function () {
      $establishmentSummary.html($establishment.val());
      $emailSummary.html($email.val());
      $contactSummary.html($contactFirst.val() + " " + $contactLast.val());
    });

    function hideNoneUsedFields(elems) {
      elems.hide();
      elems
        .find("select")
        .removeAttr("required")
        .attr("aria-required", "false");
      elems
        .find('input[type="radio"]')
        .removeAttr("required")
        .attr("aria-required", "false");
      elems
        .find('input[type="number"]')
        .removeAttr("required")
        .attr("aria-required", "false");
    }

    function makeElemsRequired(elems) {
      elems
        .find("select.required")
        .attr("required", "required")
        .attr("aria-required", "true");
      elems
        .find('input[type="radio"].required')
        .attr("required", "required")
        .attr("aria-required", "true");
      elems
        .find('input[type="number"].required')
        .attr("required", "required")
        .attr("aria-required", "true");
    }

    /**
     * Reveal the proper group form inputs
     */
    function revealElems(groupId) {
      if (groupId == orgId) {
        hideNoneUsedFields($spElems);
        hideNoneUsedFields($restaurantElems);
        hideNoneUsedFields($retailElems);
        $orgElems.show();
        makeElemsRequired($orgElems);
      } else if (groupId == spId) {
        hideNoneUsedFields($orgElems);
        hideNoneUsedFields($restaurantElems);
        hideNoneUsedFields($retailElems);
        $spElems.show();
        makeElemsRequired($spElems);
      } else if (groupId == restaurantsId) {
        hideNoneUsedFields($orgElems);
        hideNoneUsedFields($spElems);
        hideNoneUsedFields($retailElems);
        $restaurantElems.show();
        makeElemsRequired($restaurantElems);
      } else if (groupId == retailersId) {
        hideNoneUsedFields($orgElems);
        hideNoneUsedFields($spElems);
        hideNoneUsedFields($restaurantElems);
        $retailElems.show();
        makeElemsRequired($retailElems);
      }
    }

    /**
     * Debounce an event handler
     */
    function debounce(func, wait, immediate) {
      var timeout;
      return function () {
        var context = this,
          args = arguments;
        var later = function () {
          timeout = null;
          if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
      };
    }
  }

  const $addRowButton = $("#addRow");
  const $tableBody = $("#fixedAmountDonationsField tbody");

  function updateAddRowButtonVisibility() {
    const rowCount = $tableBody.find("tr").length;
    if (rowCount >= 5) {
      $addRowButton.hide(); // Hide Add Row button if 5 or more rows exist
    } else {
      $addRowButton.show(); // Show Add Row button if fewer than 5 rows
    }
  }
  // Function to add a new row
  function addRow() {
    const newIndex = $tableBody.find("tr").length;
    const rowHtml = `
          <tr>
          name="fields[fixedAmountDonations][0][amountToDonate]"
              <td><input type="number" name="fields[fixedAmountDonations][${newIndex}][col1]" required></td>
              <td><input type="number" name="fields[fixedAmountDonations][${newIndex}][col2]" min="5" required></td>
              <td><button type="button" class="delete-row">X</button></td>
          </tr>
      `;
    $tableBody.append(rowHtml);
    updateAddRowButtonVisibility();
  }

  // Add new row on button click
  $addRowButton.on("click", function () {
    addRow();
  });

  // Delete row
  $tableBody.on("click", ".delete-row", function () {
    $(this).closest("tr").remove();
    updateAddRowButtonVisibility();
  });
});
